module.exports = __webpack_public_path__ + "static/media/library.63aff301.svg";